<template>
  <div class="ushk-header">
    <div class="ushk-header__box">
      <div class="ushk-wrap ushk-wrap-main">
        <div class="ushk-header__wrap">
          <div class="ushk-header__h">
            <a href="//www.ushknews.com">
              <h1 class="ushk-header__logo">美港电讯</h1>
            </a>
          </div>

          <div v-if="!isPcFlag" class="ushk-header__r">
            <div
              @click="switchNav"
              :class="['ushk-header__btn', {'ushk-header__close': showNav}]"
            >
              <span></span>
            </div>
            <div
              class="ushk-header__act"
              v-for="menu in menus"
              v-if="setActiveState(menu.type)"
            >
              {{ menu.name }}
            </div>
          </div>

          <div v-if="showDesc" class="ushk-header__f">投资，快人一步</div>

          <transition name="fade">
            <div v-if="showNav" class="ushk-header__b">
              <ul class="ushk-header-nav">
                <li
                  v-for="menu in menus"
                  class="ushk-header-nav__item"
                  :class="[
                    `ushk-header-nav__${menu.type}`,
                    {'is-active': setActiveState(menu.type)},
                  ]"
                >
                  <a :href="menu.url">
                    <span>{{ menu.name }}</span>
                  </a>
                </li>
                <!-- <li
                  :class="[{'is-active': setActiveState('activities/index')}]"
                  class="ushk-header-nav__item ushk-header-nav__activities"
                >
                  <a href="//www.ushknews.com/activities/index.html"
                    ><img
                      v-if="setActiveState('activities/index')"
                      width="20"
                      height="20"
                      style="margin-right: 3px"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAABEVBMVEUAAAAAm76K4fiv6/qP4vlr2PeC3/he1vVR0fJTz++h5/q5//9w2/dP0vVQ0fVS1Pln2PZQ0fVP0vVQ0vVX1/hk3v88yOhV1PVR0/VP0vVP0fVQ0/VQ0/VQ0/Zb1fV43feB3/hQ0vSS4/ie5/pQ0fVQ0vWX5PlP0vQAm70Am74AnL+y7PwAnL9Q0fdR0vdS0fVV0fgAnL1V1f8Amb5Q3//n//9g1PNv2fdOyOd83feI4PhT0vWF4PiF4PhP0fWX5fim6PuS4/mX5fla1PYFn8Fd1vel6Pqs6vti1/Wm6fsAm7+m6ftR0vZR0/Zx2/pi1vdR0/a37vwAnL+J4fsAnb/C9P/S+P9T0vi/7/8Aob1P0fSRuKXAAAAAWnRSTlMAmbyj7vXW/v7+NAL89LMr/PvloBkLCP7Rx5OAZ13+9u3twLu4tquOjIZlXFtDPDInHxIREAr99PHq597d08TBsrCnp5yakZCFfntycW5jXlJKSEU8LiIiIBvMnNMgAAABL0lEQVQ4y9XT1XLDMBRF0etiGseOMczcMJWZmfn8/4dU0dR2W1t5bvfz0pyRZkR/u6hZTd2Pp5uuApaeTHdjYpSEohqYpFSvo8HmDciwyRtV4dAws5bPvJ8DT2He7UlC53Dr6O7b8kpZQ3C5M8fImxBX/kKnQH5/Nqg9DfEH4m1DE906HEeNeGuYI1ER7BBv3kF21H1920ULv1AFGeJlUBEiFcUhsYZFqELUA1LESgE9ISITep+or8Mk1uCx3Vz1I0uBOllVLJKflyXWkh9RGuh0gDSNLpkQINtAIgHD/mhIYkRZsLIxPiVE8i6QlJvSVETjet0aSELk1Q5AG8j/RA0PhVAiXgmoyeQ1csnxOnBBvFcNiC965UJOAArO8VYEogov3k+4OpgJ6rAl03/uE2+fVB0s+0mCAAAAAElFTkSuQmCC"
                      alt=""
                    />
                    <img
                      v-else
                      width="20"
                      height="20"
                      style="margin-right: 3px"
                      src="https://ushknews.oss-cn-hangzhou.aliyuncs.com/activities/img/plus%402x.png"
                      alt=""
                    />
                    <span>PLUS会员</span></a
                  >
                </li> -->
              </ul>
            </div>
          </transition>
        </div>

        <div class="ushk-header__slot">
          <slot></slot>
        </div>
      </div>
    </div>
    <div
      @click="switchNav"
      v-if="showNav && !isPcFlag"
      class="ushk-header__fixbg"
    ></div>
  </div>
</template>
<script>
import {isPC} from '@/commons/utils';
export default {
  name: 'UshkHeader',
  props: {
    showDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menus: [
        {
          type: 'news',
          name: '首页',
          url: '//www.ushknews.com',
        },
        {
          type: 'calendar',
          name: '日历',
          url: '//www.ushknews.com/calendar.html',
        },
        {
          type: 'report',
          name: '投行报告',
          url: '//www.ushknews.com/report.html',
        },
        {
          type: 'app',
          name: '下载APP',
          url: '//www.ushknews.com/app/index.html',
        },
      ],
      isPcFlag: false,
      showNav: false,
    };
  },

  components: {},
  methods: {
    setActiveState(type) {
      const href = window.location.href;
      if (
        (type === 'news' && href.indexOf('index.html') !== -1) ||
        (type === 'news' && href.indexOf('.html') === -1)
      ) {
        return true;
      }
      return href.indexOf(`${type}.html`) !== -1;
    },
    isPcFun() {
      if (isPC()) {
        this.isPcFlag = true;
        this.showNav = true;
      } else {
        this.isPcFlag = false;
        this.showNav = false;
      }
    },
    switchNav() {
      this.showNav = !this.showNav;
    },
  },
  created() {},
  mounted() {
    this.isPcFun();
    let _this = this;

    window.addEventListener('resize', function () {
      _this.isPcFun();
    });
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// Header.vue?07415340